import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { type Opportunity } from '../../models/opportunity.models';
import {
  opportunityOverviewRouteSegments,
  opportunityQualificationRouteSegments,
  opportunityStartBidRouteSegments,
  startBidNavEnabled,
} from '../../opportunity-open-navigation.util';

@Component({
  selector: 'app-opportunity-context-nav',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './opportunity-context-nav.component.html',
  styleUrl: './opportunity-context-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpportunityContextNavComponent {
  readonly opportunity = input.required<Opportunity>();

  private readonly router = inject(Router);

  protected navigateBack(): void {
    void this.router.navigate(['/opportunities']);
  }

  protected readonly overviewRouteSegments = opportunityOverviewRouteSegments;
  protected readonly qualificationRouteSegments = opportunityQualificationRouteSegments;
  protected readonly startBidRouteSegments = opportunityStartBidRouteSegments;
  protected readonly startBidEnabled = computed(() => startBidNavEnabled(this.opportunity()));
}
